import { Button } from 'antd'

import { pick } from '@eastcoal/common/utils/object'

import { useEditor } from '@eastcoal/editor/hooks/useEditor'
import { AliTextIcon } from '@eastcoal/icon/AliTextIcon'

import { INSERT_TEXT_VARIABLE_COMMAND } from '../../../../editor/plugins/TextVariablePlugin/commands'

import { TextVariableButtonProps } from './interface'

export const TextVariableButton = ({ data }: TextVariableButtonProps) => {
  const editor = useEditor()

  const handleClick = () => {
    editor.dispatchCommand(INSERT_TEXT_VARIABLE_COMMAND, {
      variable: pick(data, ['id', 'name', 'property', 'description'])
    })
  }

  return (
    <Button icon={<AliTextIcon />} type='default' onClick={handleClick}>
      {data.name}
    </Button>
  )
}
